export class Banner {
  constructor({ texts, onAccept, onReject, onConfigure, firstVisit = true, theme = 'basic' }) {
    this.texts = texts;
    this.onAccept = onAccept;
    this.onReject = onReject;
    this.onConfigure = onConfigure;
    this.firstVisit = firstVisit;
    this.theme = ['basic', 'persuasive'].includes(theme) ? theme : 'basic';
    this._root = null;
    this._keyHandler = this._onKeydown.bind(this);
  }

  show() {
    if (this._root) return;
    const root = document.createElement('div');
    root.className = `nc-banner nc-theme-${this.theme}`;
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-labelledby', 'nc-banner-title');
    root.setAttribute('aria-live', 'polite');

    const title = document.createElement('h2');
    title.id = 'nc-banner-title';
    title.className = 'nc-banner-title';
    title.textContent = this.texts.title;

    const body = document.createElement('p');
    body.className = 'nc-banner-body';
    body.textContent = this.texts.body;

    const actions = document.createElement('div');
    actions.className = 'nc-banner-actions';

    const acceptBtn = this._mkButton('nc-btn-accept', this.texts.accept, () => this._handle(this.onAccept));
    const rejectBtn = this._mkButton('nc-btn-reject', this.texts.reject, () => this._handle(this.onReject));
    const configBtn = this._mkButton('nc-btn-configure', this.texts.configure, () => this._handle(this.onConfigure));
    actions.append(acceptBtn, rejectBtn, configBtn);

    root.append(title, body, actions);
    document.body.appendChild(root);
    this._root = root;

    document.addEventListener('keydown', this._keyHandler);
    acceptBtn.focus();
  }

  hide() {
    if (!this._root) return;
    this._root.remove();
    this._root = null;
    document.removeEventListener('keydown', this._keyHandler);
  }

  _mkButton(cls, label, handler) {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = `${cls} nc-btn-equal`;
    b.textContent = label;
    b.addEventListener('click', handler);
    return b;
  }

  _handle(cb) {
    if (cb) cb();
    this.hide();
  }

  _onKeydown(e) {
    if (e.key === 'Escape') {
      if (this.firstVisit) { e.preventDefault(); return; }
      this.hide();
      return;
    }
    if (e.key === 'Tab') {
      const focusables = this._root.querySelectorAll('button');
      if (!focusables.length) return;
      const first = focusables[0], last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    }
  }
}
